import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconIncrease: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconIncrease"><Path d="M1 8L4.5 4.5L8 8" stroke="currentColor"/><Path d="M16 16L19.5 19.5L16 23" stroke="currentColor"/><Path d="M4.5 5V16" stroke="currentColor"/><Path d="M19 19.5L8 19.5" stroke="currentColor"/><Path d="M10 4.5L14 4.5" stroke="currentColor"/><Path d="M19.5 10V14" stroke="currentColor"/><Path d="M16 4.5H19.5V8" stroke="currentColor"/></CentralIconBase>;
});

export default IconIncrease;
